import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';

@Injectable()
export class OrderPickupInfoService extends ApiService {

    getOrdersPickupInfo(orderId: number, page: number = 1, limit: number = 100, q: string = '', orderField: string = '', orderDirection: string = ''): Observable<any> {
        return this.request({
            method: 'GET',
            path: `order/${orderId}/pickup-infos`,
            query: {
                q: q,
                limit: limit,
                page: page,
                orderField: orderField,
                orderDirection: orderDirection
            }
        });
    }

    getOrderPickupInfoById(orderId: number, id: number): Observable<any> {
        return this.request({
            method: 'GET',
            path: `order/${orderId}/pickup-infos/${id}`,
        });
    }


    deleteOrderPickupInfo(orderId: number, id: number): Observable<any> {
        return this.request({
            method: 'DELETE',
            path: `order/${orderId}/pickup-infos/${id}`,
        });
    }

    addOrderPickupInfo(orderId: number, body): Observable<any> {
        return this.request({
            method: 'POST',
            path: `order/${orderId}/pickup-infos`,
            body: body
        });
    }

    updateOrderPickupInfo(orderId: number, id: number, body): Observable<any> {
        return this.request({
            method: 'PUT',
            path: `order/${orderId}/pickup-infos/${id}`,
            body: body
        });
    }

    getConsolShipmentCheckpoints(id: number): Observable<any> {
        return this.request({
            method: 'GET',
            path: `shipment-consol/aftership-checkpoints/${id}`,
        });
    }
}